<template>
  <div
    style="position: fixed; top: 30px; right: 30px; z-index: 999"
    v-if="showlang"
  >
    <el-dropdown trigger="hover" @command="changeLanguage">
      <div class="headerBoxThree">
        <div>
          <img src="@/assets/fy.png" />
        </div>
        <div>
          {{ locale == "zh" ? "中文" : "" }}
          {{ locale == "en" ? "English" : "" }}
          {{ locale == "xyl" ? "Magyar" : "" }}
        </div>
        <div>
          <img src="@/assets/xl.png" />
        </div>
      </div>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="zh">中文</el-dropdown-item>
        <el-dropdown-item command="en">English</el-dropdown-item>
        <el-dropdown-item command="xyl">Magyar</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      locale: "zh",
      showlang: true,
    };
  },
  watch: {
    $route(to) {
      console.log("-----------路由", to);
      if (to.path == "/contest" || to.path == "/") {
        this.showlang = false;
      } else {
        this.showlang = true;
      }
    },
  },
  created() {
    console.log("显示了pc");
    this.locale = localStorage.getItem("i18n-lang") || "zh";
    console.log(this.locale, "显示了pcaa");
  },
  mounted() {},
  methods: {
    /* 切换语言 */
    changeLanguage(lang) {
      console.log(lang);
      this.langShow = false;
      this.$i18n.locale = lang;
      this.locale = this.$i18n.locale;
      localStorage.setItem("i18n-lang", lang);
      window.location.reload();
    },
  },
};
</script>

<style></style>
<style scoped lang="scss">
.headerBoxThree {
  display: flex;
  align-items: center;
  cursor: pointer;

  // width: 130px;
  > div:nth-of-type(1) {
    display: flex;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
    }
  }

  > div:nth-of-type(2) {
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    margin-left: 4px;
    margin-right: 10px;
  }

  > div:nth-of-type(3) {
    display: flex;
    align-items: center;

    img {
      width: 13px;
      height: 13px;
    }
  }
}
</style>
